module.exports = __webpack_public_path__ + "static/media/VMParkingIcon_01.f179d025.svg";